export class UserReportFilter {
  userReportFilterId?: number;
  userId: string;
  reportTypeId: number;
  reportTypeDescription: string;
  filterDescription: string;
  reportFilter: string;
  createUser: string;
  createTimeStamp?: Date;
  updateUser: string;
  updateTimeStamp?: Date;
  lastRunByUser: string;
  lastRunByTimeStamp?: Date;
  isReportRun: boolean;
}

export class ColumnDescription {
  columnfield: string;
  headertxt: string;

  constructor(columnfield: string, headertxt: string) {
    this.columnfield = columnfield;
    this.headertxt = headertxt;
  }
}
